import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { Globals } from '../../services/globals';

export interface ChannelRateLimitBannerDetailsDialogData {
  channel: 'rcs' | 'whatsapp';
  /**
   * API `data` object: `has_demo`, `banner_summary`, `modal_warning`, `resources[]`, etc.
   * Legacy: `bots[]` with `nc_bot_*` keys is still supported.
   */
  data: Record<string, unknown>;
}

@Component({
  selector: 'app-channel-rate-limit-banner-details-dialog',
  templateUrl: './channel-rate-limit-banner-details-dialog.component.html',
  styleUrls: ['./channel-rate-limit-banner-details-dialog.component.scss'],
})
export class ChannelRateLimitBannerDetailsDialogComponent {
  assetsUrl = '';
  constructor(@Inject(MAT_DIALOG_DATA) public bundle: ChannelRateLimitBannerDetailsDialogData, private globals: Globals) {
    this.assetsUrl = this.globals.getAssetsUrl();
  }

  get channel(): 'rcs' | 'whatsapp' {
    return this.bundle.channel;
  }

  get headline(): string {
    const t = this.bundle.data['dialog_title'];
    return typeof t === 'string' && t.trim() ? t.trim() : 'Demo limit details';
  }

  get bodySummary(): string {
    const m = this.bundle.data['modal_warning'];
    if (typeof m === 'string' && m.trim()) {
      return m.trim();
    }
    const b = this.bundle.data['banner_summary'];
    return typeof b === 'string' ? b : '';
  }

  /** Rows from `resources` (new API) or `bots` (legacy). Omits `account_type: live`. */
  get resourcesForUi(): Record<string, unknown>[] {
    const rows = this.bundle.data['resources'] ?? this.bundle.data['bots'];
    if (!Array.isArray(rows)) {
      return [];
    }
    return rows.filter((r) => {
      if (r == null || typeof r !== 'object') {
        return false;
      }
      const row = r as Record<string, unknown>;
      const at = row['account_type'];
      if (at == null || at === '') {
        return true;
      }
      return String(at).toLowerCase() !== 'live';
    }) as Record<string, unknown>[];
  }

  resourceDisplayName(row: Record<string, unknown>): string {
    const n = row['resource_name'] ?? row['nc_bot_name'];
    if (typeof n === 'string') {
      return n;
    }
    return n != null ? String(n) : '';
  }

  /** Demo rows with limits; live-only rows omit `daily_limit` / `sent`. */
  resourceHasUsage(row: Record<string, unknown>): boolean {
    return row['daily_limit'] != null && row['sent'] != null;
  }

  botLimitReached(bot: Record<string, unknown>): boolean {
    if (bot['limit_reached'] === false) {
      return false;
    }
    if (bot['limit_reached'] === true) {
      return true;
    }
    const sent = Number(bot['sent']);
    const lim = Number(bot['daily_limit']);
    return lim > 0 && sent >= lim;
  }

  botPercent(bot: Record<string, unknown>): number {
    const usagePct = bot['usage_percent'];
    if (usagePct != null && usagePct !== '' && Number.isFinite(Number(usagePct))) {
      return Math.min(100, Math.round(Number(usagePct)));
    }
    const sent = Number(bot['sent']);
    const lim = Number(bot['daily_limit']);
    if (!lim) {
      return 0;
    }
    return Math.min(100, Math.round((sent / lim) * 100));
  }
}
